<template>
  <div :class="ui.bkgdColor">
    <div v-show="false"> {{getResultsListCounter}} </div>
    <div v-if="listReactive.length !== 0" class="mt-4">
      <div v-for="item in listReactive" :key="item.basic.idi">
        <v-layout row class="ml-4 mr-4 mt-2">
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-avatar>
              <div :class="ui.textSubheadingBold">
                {{item.basic.idi}}
              </div>
            </v-avatar>
            <div :class="ui.textSubheading">
              {{item.basic.title}}
            </div>
          </v-chip>
          <v-spacer/>
          <ResultsUpdate v-if="enableResultUpdate" :engResults="item"/>
          <div class="mr-2 mt-2"/>
          <ResultsRead v-if="enableResultRead" :engResults="item"/>
          <div class="mr-2 mt-2"/>
          <ResultsEdit v-if="enableResultEdit" :engResults="item"/>
        </v-layout>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import ResultsRead from "@/engineering/results/components/ResultsRead";
import ResultsEdit from "@/engineering/results/components/ResultsEdit";
import ResultsUpdate from "@/engineering/results/components/ResultsUpdate";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  // eslint-disable-next-line
  mixins: [master, apptheme],
  // eslint-disable-next-line
  components: {
    ResultsRead,
    ResultsUpdate,
    ResultsEdit
  },
  props: {
    datas: {
      type: Object
    }
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getResultsList",
      "getResultsListCounter",
      "getDetail",
      "getDetail",
      "getCurrentPage"
    ]),
    list() {
      // eslint-disable-next-line
      if (this.getResultsList !== undefined && this.getResultsList.length !== 0) {
        return this.getResultsList; // used for new datas
      } else if (this.getResultsList === undefined) {
        return [];
      } else if (this.getResultsList.length !== 0) {
        return this.getResultsList;
      } else {
        return [];
      }
    },
    enableResultEdit() {
      let logic = false;
      if (
        this.getCurrentPage === "/worktooldetail" ||
        this.getCurrentPage === "/reportdetail"
      ) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    enableResultRead() {
      let logic = false;
      if (this.getCurrentPage === "/worktooldetail") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    enableResultUpdate() {
      let logic = false;
      if (
        this.getCurrentPage === "/worktooldetail" ||
        this.getCurrentPage === "/reportdetail"
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  beforeMount() {
    // to cater for bug due to array reactivity
    this.listReactive = this.getResultsList;
  },
  updated() {
    // getResultsListCounter triggers the counter =
    this.listReactive = this.getResultsList;
  },
  data() {
    return {
      listReactive: []
    };
  }
};
</script>
